import "./Login.css"

import {use, useState} from "react"
import login from "../../services/api/Auth";
import useAccessToken from "../../hooks/useToken";
import {useNavigate} from "react-router-dom";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import PrimaryInput from "../../components/primaryInput/PrimaryInput";
import PrimaryLabel from "../../components/primaryLabel/PrimaryLabel";
import {ErrorMessage} from "../../components/errorMessage/ErrorMessage";
import {useDashboardLocale} from "../../context/dashboard_locale";
import {capitalize} from "../../utils/strings";

export default function Login() {
    const {strings} = useDashboardLocale()
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(null)
    const {setToken} = useAccessToken();
    const navigate = useNavigate();

    function onFormSubmit(e) {
        e.preventDefault();

        if (!username.trim()) {
            setErrorMessage(strings["username_required"])
            return;
        }
        if (!password.trim()) {
            setErrorMessage(strings["password_required"])
            return;
        }

        setErrorMessage(null);
        login(username, password).then(res => {
            const accessToken = res.data["response"]["access_token"];
            setToken(accessToken);
            navigate("/dashboard/exhibitions");
        }).catch(err => {
          console.log(err);
            const errMessage = err.response.data["error_message"]
            setErrorMessage(errMessage);
        });
    }

    function onChangeUsername(e) {
        setErrorMessage(null);
        setUsername(e.target.value.toLowerCase())
    }

    function onChangePassword(e) {
        setErrorMessage(null);
        setPassword(e.target.value)
    }

    return (
            <div className="h-screen flex justify-center items-center">
                <div className="w-full max-w-md">
                    <form className="shadown-md bg-white text-left rounded p-6 flex flex-col space-y-4" onSubmit={onFormSubmit}>
                        <h4 className="text-lg text-center font-bold c-primary">{strings["dashboard"]}</h4>
                        <div>
                            <PrimaryLabel>{capitalize(strings["username"])} <span className={"text-red-500 font-medium"}>*</span></PrimaryLabel>
                            <PrimaryInput
                                name="username"
                                type="text"
                                placeholder={strings["username_prompt"]}
                                onChange={onChangeUsername}
                            >
                                {username}
                            </PrimaryInput>
                        </div>
                        <div>
                            <PrimaryLabel>{capitalize(strings["password"])} <span className={"text-red-500 font-medium"}>*</span></PrimaryLabel>
                            <PrimaryInput
                                name="password"
                                type="password"
                                placeholder={strings["password_prompt"]}
                                onChange={onChangePassword}
                            >
                                {password}
                            </PrimaryInput>
                        </div>
                        <div>
                            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                        </div>
                        <div>
                            <PrimaryButton
                                name="submit"
                                extraClassName="w-full"
                            >
                                {capitalize(strings["sign_in"])}
                            </PrimaryButton>
                        </div>
                    </form>
                </div>
            </div>
    );
}